import { Trans, useTranslation } from "react-i18next";
import {
  ContactEmail,
  ContactLink,
  ListContaniner,
  MailOutlineStyled,
  PrivacyPolicyText,
  SectionContainer,
  SectionTitle,
} from "../PrivacyPolicyContent.styled";

export const ContactSectionContent = (props: ContactSectionContentProps) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.contact.title"} />
      </SectionTitle>
      <ListContaniner>
        <PrivacyPolicyText>
          <Trans i18nKey={"privacyPolicy.contact.text"} />
        </PrivacyPolicyText>
        <ContactEmail href="mailto:marketing@tremium.net">
          <MailOutlineStyled />
          <ContactLink>{i18n.t("common.martketingLink")}</ContactLink>
        </ContactEmail>
      </ListContaniner>
    </SectionContainer>
  );
};

export interface ContactSectionContentProps {}
